import {message} from "antd";
import DeviceReregistrationFirstForm
    from "../../../forms/DeviceRegistrationForms/Reregistration/DeviceReregistrationFirstForm";
import "../DeviceBaseRegistration.css";

const DeviceReregistrationFirst = () => {
    const handleClear = (form) => {
        form.resetFields();
        localStorage.removeItem("deviceReRegistrationStep1")
        localStorage.removeItem("deviceReRegistrationStep2")
        message.info("Form cleared");
    };

    const uploadProps = {
        name: "file",
        multiple: false,
        accept: ".pdf",
        maxCount: 1,
        beforeUpload: () => false, // Prevent auto-uploading
    };

    return (
        <DeviceReregistrationFirstForm
            handleClear={handleClear}
            uploadProps={uploadProps}
        />
    );
};

export default DeviceReregistrationFirst;
